import { render, staticRenderFns } from "./ErrorBookedNoticeCardMobile.vue?vue&type=template&id=4ac25244&scoped=true"
import script from "./ErrorBookedNoticeCardMobile.vue?vue&type=script&lang=js"
export * from "./ErrorBookedNoticeCardMobile.vue?vue&type=script&lang=js"
import style0 from "./ErrorBookedNoticeCardMobile.vue?vue&type=style&index=0&id=4ac25244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac25244",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VChip,VIcon})
